module.exports = __webpack_public_path__ + "img/img3.90cf3318.png";